module.exports = __webpack_public_path__ + "img/hero.615683dc.png";